const useAccount = account => {
  const {
    entitlements = [],
    transacteds = [],
    availableBalance,
    salaryDeductionAmount,
    currency,
    isUnlimited,
  } = account;

  let pointAllocations = [],
    broughtForwardPoints = [],
    totalPointAllocation = 0,
    totalBroughtForwardPoints = 0,
    totalEntitlement = 0;

  for (const item of entitlements) {
    if (
      item.transactionTypeId == "PointsAllocation" ||
      item.transactionTypeId == "PointsAdjustment" ||
      item.transactionTypeId == "FlexPointAllocation" ||
      item.transactionTypeId == "FlexPointAdjustment"
    ) {
      totalPointAllocation += item.actualAmount;
      pointAllocations.push(item);
    } else if (
      item.transactionTypeId == "BroughtForward" ||
      item.transactionTypeId == "CarryForward" ||
      item.transactionTypeId == "Forfeiture"
    ) {
      totalBroughtForwardPoints += item.actualAmount;
      broughtForwardPoints.push(item);
    }
  }

  let benefitSelection = [],
    restUtilization = [],
    totalBenefitSelection = 0,
    totalUtilized = 0,
    totalSpend = 0;
  for (const item of transacteds) {
    if (
      item.transactionTypeId == "BenefitSelection" ||
      item.transactionTypeId == "BenefitSelectionAdjustment" ||
      item.transactionTypeId == "UnderwritingAcceptance" ||
      item.transactionTypeId == "UnderwritingDecline"
    ) {
      if (item.actualAmount > 0) {
        totalPointAllocation += item.actualAmount;
        pointAllocations.push(item);
      } else {
        totalBenefitSelection += item.actualAmount;
        benefitSelection.push(item);
      }
    } else {
      totalUtilized += item.actualAmount;
      restUtilization.push(item);
    }
  }
  totalSpend = totalBenefitSelection + totalUtilized;
  totalEntitlement = totalPointAllocation + totalBroughtForwardPoints;
  return {
    entitled: totalEntitlement,
    totalSpend,
    available: availableBalance,
    salaryDeductionAmount,
    currency,
    isUnlimited,
    pointAllocations,
    totalPointAllocation,
    broughtForwardPoints,
    totalBroughtForwardPoints,
    benefitSelection,
    totalBenefitSelection,
    restUtilization,
  };
};
export default useAccount;



// WEBPACK FOOTER //
// ./components/claim/hooks/useAccount.js